import { render, staticRenderFns } from "./performance_schedule_table.vue?vue&type=template&id=2ddc9d61&"
import script from "./performance_schedule_table.vue?vue&type=script&lang=js&"
export * from "./performance_schedule_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports